import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/** Met à jour title / description / robots / canonical / Open Graph par page. */
export function useHead({ title, description, robots = "index,follow", canonical }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
    }
    if (title) upsertMeta("property", "og:title", title);
    upsertMeta("name", "robots", robots);
    upsertMeta("property", "og:type", "website");
    const url = canonical || (typeof window !== "undefined" ? window.location.href : undefined);
    if (url) {
      upsertCanonical(url);
      upsertMeta("property", "og:url", url);
    }
  }, [title, description, robots, canonical]);
}

export default useHead;
